import registerTypes from './types';
import registerUnits from './units';
import registerGainTypes from './gain_types';
import registerPriorities from './priorities';
import registerStatus from './status';
import registerTechnicians from './technicians';
import module from './module';
import plugins from './plugins';

export default (store) => {
  module(store);

  plugins(store);

  registerTypes(store);
  registerUnits(store);
  registerGainTypes(store);
  registerPriorities(store);
  registerStatus(store);
  registerTechnicians(store);
};
